module.exports = __webpack_public_path__ + "media/images/guide-1-d3cdde377f14ae3478c9dfb96576a841.png";